import React, { useId } from "react";
import styled from "styled-components/macro";
import { SudoTooltip } from "../../sudokit/components/SudoTooltip";

const Choice = styled.label`
  display: flex;
  align-items: flex-start;
  text-align: left;
  line-height: 1.4;
  gap: 10px;
  margin: 12px 0;
  font-size: 15px;
  color: var(--grey-0);
  cursor: ${({ $disabled }) => $disabled ? "not-allowed" : "pointer"};
  .choice-title { color: ${({ $disabled }) => $disabled ? "var(--grey-1)" : "inherit"}; }
  input { width: 18px; height: 18px; margin-top: 2px; flex-shrink: 0; accent-color: var(--primary-cta); }
  .credit-disclosure {
    display: block;
    margin-top: 4px;
    color: var(--grey-1);
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
  }

`;

export default function ManuscriptReportChoice({ choice, disabled = false }) {
  const descriptionId = useId();
  if (!choice.ready) return <p role="status">Loading import options…</p>;
  if (!choice.visible) return null;
  return <Choice $disabled={disabled || choice.insufficientCredits}>
    <input type="checkbox" checked={choice.checked} aria-label="Create Manuscript Report" aria-describedby={choice.showCreditCopy ? descriptionId : undefined}
      disabled={disabled || choice.insufficientCredits}
      onChange={(event) => choice.setChecked(event.target.checked)} />
    <span><SudoTooltip
      triggerAs="span"
      role="tooltip"
      customContent={<><strong>Check this box to get a Manuscript Report:</strong> a summary of your project, detailed feedback, and a prioritized checklist of next steps.</>}
    >
      <span className="choice-title">Create Manuscript Report</span>
    </SudoTooltip>
      {choice.showCreditCopy && <small id={descriptionId} className="credit-disclosure">
        <span>
        {choice.isTrial ? <><s>Uses Credits</s> — Your first two reports are free!</> :
          choice.insufficientCredits ? "Uses Credits — Not enough credits" : "Uses Credits"}
        </span>
      </small>}
    </span>
  </Choice>;
}
